module.exports = __webpack_public_path__ + "images/feature/20130610-progress-1-e0d977706900511b75f47c478ae6d7ba.jpg";